import {
  buildForeignAddress,
  IDENTITY_TYPE,
  normalizeForeignPostalCode,
  normalizeIdentity,
  normalizeZipCode,
  resolveSubmittedIdentityType,
  type SignupRequest,
} from '@src/domains/customers';
import { isForeignBuyerSelection, resolveCountryCode } from './resolveSignupFields';
import type { SignupFormValues } from '../types/signupFormValues';

type BuildSignupPayloadOptions = {
  allowForeignBuyers: boolean;
};

export function buildSignupPayload(values: SignupFormValues, options: BuildSignupPayloadOptions): SignupRequest {
  const { allowForeignBuyers } = options;
  const isForeign = isForeignBuyerSelection(values, allowForeignBuyers);
  const zipCode = isForeign ? normalizeForeignPostalCode(values.zipCode) : normalizeZipCode(values.zipCode);

  return {
    email: values.email.trim(),
    firstName: values.firstName.trim(),
    lastName: values.lastName.trim(),
    corporateName: values.identityType === IDENTITY_TYPE.CNPJ ? values.corporateName?.trim() || null : null,
    countryCode: resolveCountryCode(values, allowForeignBuyers),
    identityType:
      resolveSubmittedIdentityType(isForeign, values.identityType, values.foreignIdentityType ?? null) ??
      values.identityType,
    identity: normalizeIdentity(values.identity),
    // Not collected by the new form: the API still requires the key, so it goes out empty.
    birthdate: null,
    address: buildForeignAddress(zipCode),
    password: values.password,
    phone: values.phone.trim(),
    agreesToTerms: values.agreesToTerms,
    recaptchaToken: values.recaptchaToken,
  };
}
